import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UiControlValueAccessorDirective } from '../../basics/ui-control-value-accessor';
import { takeUntil } from 'rxjs';
import { getRandomId } from '../../utils/get-random-id';
import { BoschUiValidationErrorComponent } from '../bosch-ui-validation-error/bosch-ui-validation-error.component';
import { provideCustomCVA } from '../../basics/ui-custom-cva.provider';
import { TranslateModule } from '@ngx-translate/core';
import { BoschUiIconComponent } from '../bosch-ui-icon/bosch-ui-icon.component';
import { BoschUiIconNames } from '../bosch-ui-icon/bosch-ui-icon.constants';
import { BoschUiDisableControlDirective } from '../../directives/bosch-ui-disable-control/bosch-ui-disable-control.directive';

@Component({
  selector: 'bosch-ui-input-datetime',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BoschUiValidationErrorComponent,
    TranslateModule,
    BoschUiIconComponent,
    BoschUiDisableControlDirective,
  ],
  templateUrl: './bosch-ui-input-datetime.component.html',
  styleUrls: ['./bosch-ui-input-datetime.component.scss'],
  providers: [provideCustomCVA(BoschUiInputDatetimeComponent)],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
// TODO: component is not ready. momentjs or date-fns adapter must be implemented
export class BoschUiInputDatetimeComponent extends UiControlValueAccessorDirective<string | null> implements OnInit {
  @Input() label: string | null = null;
  @Input() placeholder = '';
  @Input() readonly = false;
  @ViewChild('input') input: ElementRef | null = null;
  @ContentChild(BoschUiValidationErrorComponent, { static: false }) errorRef: BoschUiValidationErrorComponent | null =
    null;
  readonly id: string = getRandomId('input-datetime');
  iconNames = BoschUiIconNames;

  override ngOnInit(): void {
    super.ngOnInit();

    this.control.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: string | null) => {
      this.onChange(value);
    });
  }

  showPicker(): void {
    if (this.input) {
      this.input.nativeElement.showPicker();
    }
  }
}
